import { render, staticRenderFns } from "./SpeakerAdd.vue?vue&type=template&id=1b2d7353&scoped=true&"
import script from "./SpeakerAdd.vue?vue&type=script&lang=js&"
export * from "./SpeakerAdd.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerAdd.vue?vue&type=style&index=0&id=1b2d7353&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d7353",
  null
  
)

export default component.exports